import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import ShopPaymentsApi from '../generated/api/ShopPayments';

export default (service: Servicelayer) => ({
  ...ShopPaymentsApi(service),

  // Add custom calls here

});
